<template>
  <div class="top-toolbar" :class="theme">
    <div class="user-profile-content">
      <el-dropdown>
        <div class="v-middle user-info">
          <i class="fas fa-user"></i>
          <span class="user-name">{{userInfo.name}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    theme: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    ...mapActions(["logout"])
  }
};
</script>
